/* unplugin-vue-components disabled */import script from "./date.vue?vue&type=script&setup=true&lang=ts"
export * from "./date.vue?vue&type=script&setup=true&lang=ts"

import "./date.vue?vue&type=style&index=0&id=29b9471a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29b9471a"]])

export default __exports__